export class TenantNotFoundController {
    static $inject = ['DEFAULT_PORTAL_URL', 'LoadingService', 'TenantService', '$state'];
    constructor(DEFAULT_PORTAL_URL, LoadingService, TenantService, $state) {
        'ngInject';
        this.DEFAULT_PORTAL_URL = DEFAULT_PORTAL_URL;
        this.LoadingService = LoadingService;
        this.TenantService = TenantService;
        this.$state = $state;
        this.LoadingService.stopLoading();
        this.blipDomain = this.DEFAULT_PORTAL_URL;
        this.pureDomain = this.TenantService.getDefaultPortalUrl(false);
    }
    goBack() {
        this.$state.go('auth.application.list');
        return;
    }
}
TenantNotFoundController.$inject = ['DEFAULT_PORTAL_URL', 'LoadingService', 'TenantService', '$state'];
